/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'
import { type RelatedLink, RelatedLinkSchema } from './related-link'

/* TypeScript */
export type RelatedLinkApiProps = {
  technicalName?: Maybe<string>
  title?: Maybe<string>
  subtitle?: Maybe<string>
  links: CTALink[] | RelatedLink[]
  align?: Maybe<'Left' | 'Center'>
  display?: Maybe<'Wrap' | 'Inline-Scroll'>
  size?: Maybe<'Small' | 'Medium'>
}

/* Schemas */
export const RelatedLinkApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
  links: z.union([z.array(CTALinkSchema), z.array(RelatedLinkSchema)]),
  align: z.nullish(z.enum(['Left', 'Center'])),
  display: z.nullish(z.enum(['Wrap', 'Inline-Scroll'])),
  size: z.nullish(z.enum(['Small', 'Medium'])),
})

/* Schemas validation */
type TestRelatedLinkProps = ExpectTrue<
  Equal<RelatedLinkApiProps, z.infer<typeof RelatedLinkApiPropsSchema>>
>
